export { NetworkHTTP as KBNetworkHTTP } from './adapters/network_http';
export { NetworkNone as KBNetworkNone } from './adapters/network_none';
export { NetworkWS as KBNetworkWS } from './adapters/network_ws';

export { NavKnowledgeBotMixin } from './mixins/kbi_mixin';
export { KnowledgeBot } from './core/knowledge_bot';

export * from './delegates/kbi_delegate';
export * from './types/bot_interface';
export * from './types/network';

import { NavKnowledgeBotToggleElement } from './components/knowledge-bot-toggle';
import { NavKnowledgeBotElement } from './components/knowledge-bot';
import './components/knowledge-bot';

import { DelegateKBI } from './delegates/kbi_delegate';

import { style as styleInterface } from './styling/interface';
import { style as styleMarkdown } from './styling/markdown';

import { NavKnowledgeBotMixin } from './mixins/kbi_mixin';
import { KnowledgeBot } from './core/knowledge_bot';
import { IconDB } from './styling/icon_db';
import { LitElement } from 'lit';

export class NavigateKnowledgeBot {
  readonly id = 'nav/knowledge-bot/index';
  readonly crate = 'nav/knowledge-bot';
  readonly ns = 'nav';

  readonly styles = {
    interface: styleInterface,
    markdown: styleMarkdown
  };

  /**
   * @returns icon dictionary
   */
  botIcons() {
    return IconDB;
  }

  /**
   * @returns a new bot
   */
  createBot() {
    return new KnowledgeBot();
  }

  applyBotMixin(superClass: typeof LitElement) {
    return NavKnowledgeBotMixin(superClass);
  }

  /**
   * render the toggle button
   */
  renderButton() {
    return new NavKnowledgeBotToggleElement();
  }

  /**
   * @returns delegate for kbi
   */
  delegate() {
    return DelegateKBI.instance();
  }
}

export default new NavigateKnowledgeBot();
